<template>
  <div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">

      <div style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">

        <div style="width:40%;display:flex">
          <div style="width:4px;background-color:#970B0B;height:40px"></div>
          <div style="margin:5px;color:#970B0B;">自动化任务</div>
        </div>
        <div style="width:50%;justify-content: center;display: flex;">
        </div>
        <div style="width:15%;color:#970B0B">
          <el-button @click="RightAddClick" size="mini"
            style="width:70%;background-color:#970B0B;color:#fff">新增</el-button>

        </div>

      </div>

    </div>

    <div style="width:100%;height:100%">

      <el-table :data="sceneList" height="500px" size="medium" style="width: 100%;">
        <el-table-column fixed prop="id" label="id" width="80"></el-table-column>

        <el-table-column prop="cid" label="设备" width="180"></el-table-column>
                <el-table-column prop="aid" label="AID" width="80"></el-table-column>

        <el-table-column prop="combinename" label="名称" width="350"></el-table-column>

        <el-table-column prop="status" label="是否开启" width="80"></el-table-column>

        <el-table-column prop="autotype" label="触发类型" width="120"></el-table-column>


        <el-table-column prop="demand" label="触发条件" width="1000"></el-table-column>

        <el-table-column prop="params" label="执行命令" width="1000"></el-table-column>


        <el-table-column prop="createDate" label="创建时间" width="200">
        </el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="200">
        </el-table-column> 


        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button  size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button  size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>



 <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>



    <el-dialog :visible.sync="scenejobcenterDialogVisible" width="80%" center :destroy-on-close=true :show-close=false
      :close-on-click-modal=false :close-on-press-escape=false>
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div v-if="!isGroupEdit"  style="margin:5px;color:#970B0B;">新增自动化任务</div>
              <div v-if="isGroupEdit"  style="margin:5px;color:#970B0B;">编辑自动化任务</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">


            <div style="width:70%;display:flex">


              <div v-if="isGroupEdit" style="display: flex;margin:10px;">
                <div style="flex: 1;width:40px;margin-left:5px;margin-top:5px">ID：{{ groupInfo.id }}
                </div>
              </div>



              <div style="display: flex;margin-left:0px;margin-top:11px;">
                <div style="flex: 1;width:220px;margin:5px;margin-right:0px">类型:</div>
                <el-select @change="selectAutoType" size="medium" placeholder="请选择触发类型" v-model="autotype">

                  <el-option v-for="item in ccAutoTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <div style="display: flex;margin-left:0px;margin-top:11px;">
                <div style="flex: 1;width:220px;margin:5px;margin-right:0px">设备:</div>
                <el-select @change="selectChangeDemand" size="medium" placeholder="请选择触发设备" v-model="cid">

                  <el-option v-for="item in ccprojectList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>



              <div style="display: flex;margin-left:0px;margin-top:11px;">
                <div style="flex: 1;width:220px;margin:5px;margin-right:0px">启用:</div>
                <el-select @change="selectSceneStatus" size="medium" placeholder="请选择是否开启" v-model="status">

                  <el-option v-for="item in ccsceneStatusList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>


            </div>


            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>








        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">


            <div style="width:70%;display:flex">


  
                <div style="display: flex;margin-left:10px;margin-top:10px;">
                    <div style="flex: 1;width:40px;margin:5px;margin-right:10px">名称:</div>
                    <el-input
                    style="width:800px;"
                     placeholder="自动化任务名称"
                     v-model="groupInfo.combinename"
                     type="text"
                     clearable>
                    </el-input>
                    </div>









            </div>


            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>







 <div style="height:140px;width:100%;background-color:#f8f8f8;">
          <div  style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
          
              <div style="width:70%;display:flex" > 
            


                    <div style="display: flex;margin-left:20px;margin-top:10px;">
                      <div style="flex: 1;width:80px;margin:5px;margin-right:10px">触发指令</div>
                      <el-input
                      style="width:800px;"
                       placeholder="请输入触发指令参数,JSON格式,最外层是数组[],为空请填写[]"
                       v-model="groupInfo.demand"
                       type="textarea"
                       :rows="5"
                       clearable>
                      </el-input>
                    </div>

              
              </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
      </div>

    </div>

     <div style="height:140px;width:100%;background-color:#f8f8f8;">
          <div  style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
          
              <div style="width:70%;display:flex" > 
            


                    <div style="display: flex;margin-left:20px;margin-top:10px;">
                      <div style="flex: 1;width:80px;margin:5px;margin-right:10px">执行指令</div>
                      <el-input
                      style="width:800px;"
                       placeholder="请输入执行指令参数,JSON格式,最外层是数组[],为空请填写[]"
                       v-model="groupInfo.params"
                       type="textarea"
                       :rows="5"
                       clearable>
                      </el-input>
                    </div>

              
              </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
      </div>

    </div>

    <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">提醒：所有信息为必填，指令参数JSON格式！可以使用在线工具编辑JSON：https://www.json.cn</div>







      </div>

      <span slot="footer" class="dialog-footer ">
        <el-button style="width:120px" @click="scenejobcenterDialogVisible = false">取 消</el-button>
        <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="addGroup">确 定</el-button>
      </span>
    </el-dialog>






  </div>

</template>

<script>

import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import { formatTime,isJsonType } from 'TMUtils'


export default {
  methods: {
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getCombineAutoListByPage(_this.pageInfo.val,_this.pageInfo.size);
      },
    handleDelete(index, rows) {
      var _this = this;

      _this.$confirm('此操作将永久删除, 是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

        _this.deleteGroup(rows.id)



      }).catch(() => {

      });

    },


    handleEdit(index, rows) {
    this.scenejobcenterDialogVisible = true;
    this.isGroupEdit = true;

      this.groupInfo = {
        group:rows.group,
        id:rows.id,
        cid:rows.cid,
        autotype: rows.autotype,
        demand:rows.demand,
        params:rows.params,
        status:rows.status,
        combinename:rows.combinename,

      }
      this.cid =rows.cid
      
      this.status =rows.status
      this.autotype =rows.autotype



    },
    editDeviceBandInfo() {

      var _this = this


      if (!_this.groupInfo.username || !_this.groupInfo.aid) {
        this.$message.error("请输入相关信息");
        return
      }


      var params = {
        aid: _this.groupInfo.aid,
        cid: _this.groupInfo.cid,
        username: _this.groupInfo.username,
      }
      var reqdata = {}
      var {  urls } = _this.getresult(TMApipath.SCENEMANAGE, TMApipath.URL_API_EDITDEVICEBANDINFO, reqdata);

      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.scenejobcenterDialogVisible = false;

          // 演示2S拉取
          setTimeout(_this.getCombineAutoListByPage(_this.pageInfo.val, _this.pageInfo.size), 200);



        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });


    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // console.log(`当前页: ${val}`);
      var _this = this
      _this.pageInfo.val = val
      _this.getCombineAutoListByPage(_this.pageInfo.val, _this.pageInfo.size);

    },
    preclick(val) {
      console.log(`当前页: ${val}`);

    },

    RightAddClick() {

      this.status = '';

      this.cid = '';

      this.groupInfo =  {


        id:'',
        aid:'',
        cid:'',
        status:'',
        autotype:'',
        demand:'',
        params:'',
        combinename:'',
      },
      this.isGroupEdit = false

      this.scenejobcenterDialogVisible = true;

    },

    updateGroup(){

        var _this = this

        console.log(_this.groupInfo.status )


          if (!_this.groupInfo.cid ||  !_this.groupInfo.params || !_this.groupInfo.demand|| !_this.groupInfo.combinename  || !_this.groupInfo.autotype || _this.groupInfo.status === "") {
              _this.$message.error("请填写相关必填信息");
            return
          }



          if (_this.groupInfo.demand ==="" || !isJsonType( _this.groupInfo.demand )  ) {
                _this.$message.error("触发条件指令参数为空或不是json");

              return
          }

          if (_this.groupInfo.params ==="" || !isJsonType( _this.groupInfo.params )) {
                _this.$message.error("执行命令参数为空或不是json");

              return
          }

          var ccparams  = JSON.parse(_this.groupInfo.params );
          var ccdemand  = JSON.parse(_this.groupInfo.demand );

          var params = {
            id: _this.groupInfo.id,
            aid: _this.aid,
            cid: _this.groupInfo.cid,

            status: _this.groupInfo.status,
            autotype: _this.groupInfo.autotype,
            params:ccparams,
            demand:ccdemand,
            combinename: _this.groupInfo.combinename

          }
          

         var reqdata = {}
          var { urls} = _this.getresult(TMApipath.COMBINECONTROLL,TMApipath.URL_API_editCombineAuto, reqdata);

           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(urls, params).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
                _this.scenejobcenterDialogVisible = false;

              // vuex记录
              _this.getCombineAutoListByPage(_this.pageInfo.val,_this.pageInfo.size);

            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },


    deleteGroup(id) {

      var _this = this

      var params = {
        id: id
      }
      var reqdata = {}
      var {  urls } = _this.getresult(TMApipath.COMBINECONTROLL, TMApipath.URL_API_deleteCombineAuto, reqdata);

      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.scenejobcenterDialogVisible = false;

          // vuex记录
          _this.getCombineAutoListByPage(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });

    },
     addGroup(){

          var _this = this;



          if (_this.isGroupEdit) {
            _this.updateGroup();
            return;
          }




          if (!_this.groupInfo.cid || !_this.groupInfo.params|| !_this.groupInfo.demand  || !_this.groupInfo.autotype || !_this.groupInfo.combinename  || _this.groupInfo.status === "" ) {
              _this.$message.error("请填写相关必填信息");
            return
          }



          if (_this.groupInfo.demand ==="" || !isJsonType( _this.groupInfo.demand )) {
                _this.$message.error("前置指令参数为空或不是json");

              return
          }

          if (_this.groupInfo.params ==="" || !isJsonType( _this.groupInfo.params )) {
                _this.$message.error("执行指令参数为空或不是json");

              return
          }



          var ccdemand  = JSON.parse(_this.groupInfo.demand );
          var ccparams  = JSON.parse(_this.groupInfo.params );


     
          var params = {

            aid: _this.aid,
            cid: _this.groupInfo.cid,
            status: _this.groupInfo.status,
            autotype: _this.groupInfo.autotype,
            demand:ccdemand,
            params:ccparams,
            combinename: _this.groupInfo.combinename
          }
          
// console.log("params456:",params)

      
          var reqdata = {}
          var { urls} = _this.getresult(TMApipath.COMBINECONTROLL,TMApipath.URL_API_addCombineAuto, reqdata);

          console.log(urls)

           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(urls, params).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
                _this.scenejobcenterDialogVisible = false;
              // vuex记录
                _this.getCombineAutoListByPage(_this.pageInfo.val,_this.pageInfo.size);
            }else{
              _this.$message.error(response.msg);
            }
            
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
              _this.$message.error("系统异常");
            console.log(response)
          });



      },

    selectChangeDemand(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccprojectList){
                var item = _this.ccprojectList[items]


               if (item.value === val) {
                  _this.groupInfo.cid = item.key ;

                  break;
               }

          }
      },
      selectSceneStatus(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccsceneStatusList){
                var item = _this.ccsceneStatusList[items]


               if (item.value === val) {
                  _this.groupInfo.status = item.key;

                  _this.status = item.key;

                  break;
               }

          }
      },
      selectAutoType(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccAutoTypeList){
                var item = _this.ccAutoTypeList[items]


               if (item.value === val) {
                  _this.groupInfo.autotype = item.key;

                  _this.autotype = item.key;

                  break;
               }

          }
      },
    getCombineAutoListByPage(pageIndex, pageSize) {
      var _this = this

      var reqdata = { pageIndex: pageIndex, pageSize: pageSize,aid:_this.aid }
      var {  urls } = _this.getresult(TMApipath.COMBINECONTROLL, TMApipath.URL_API_getCombineAutoListByPage, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          // vuex记录
          _this.sceneList = [];
                _this.pageInfo.total = response.data.total
          for (var items in response.data.list) {
            var item = response.data.list[items]
            var cutFeed = {
              id: item.id,
              aid: item.aid,
              cid: item.cid,
              autotype: item.autotype,
              demand: item.demand,
              params: item.params,
              combinename: item.combinename,
              status: item.status,
              createDate: item.createDate ? formatTime(item.createDate): '--',
              updateDate: item.updateDate!='' ? formatTime(item.updateDate) : '--'
            }
            _this.sceneList.push(cutFeed);
          }
        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    },
    getDeviceListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.DEVICE, TMApipath.URL_API_GETDEVICELISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.ccprojectList =[];

                // _this.pageInfo.total = response.data.total

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  id: item.id,
                  cid: item.cid,
                  key:item.cid,
                  value:item.cid,

                }

                _this.ccprojectList.push(cutFeed);
              }




            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },

  },
  mounted() {
    var _this = this
    _this.aid = TMStore.state.account.aid
    _this.username = TMStore.state.account.username
       _this.getDeviceListByPage(1,100);

    _this.getCombineAutoListByPage(_this.pageInfo.val, _this.pageInfo.size);

  },
  data() {
    return {
      aid: '',
      username: '',
      role: '',

      pageInfo: {
        val: 1,
        size: 10,
        total: 0
      },
      scenejobcenterDialogVisible: false,
      isGroupEdit: false,


      groupInfo: {
        id:'',
        aid:'',
        cid:'',
        status:'',
        autotype:'',
        demand:'',
        params:'',
        combinename:'',

      },
      groupIist: [],
      projectkey: '',
      project: '',
      sceneList: [],

      ccprojectList:[],

      grouptype:'',
      group:'',
      status:'',
      autotype:'',
      cid:'',
      ccsceneStatusList:[{key:1,value:"开启"},{key:0,value:"关闭"}],
      ccAutoTypeList:[{key:"demand_and",value:"全部满足"},{key:"demand_or",value:"一个满足"}],


    }
  }
}
</script>

<style scoped>
.groups {
  overflow: hidden 
}
.rightButton {
  width: 30px 
}
.container_right {
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: flex-start; 
}

.el-dialog_header {
  padding:0px
} 
</style>